import loadTypes from 'utils/loadTypes'
import groupBy from 'lodash/groupBy'

export const FUNNEL_CONVERSION = loadTypes('FUNNEL_CONVERSION')
export const FUNNEL_CONVERSION_FOR_CHANNEL = loadTypes('FUNNEL_CONVERSION_FOR_CHANNEL')
export const FUNNEL_TOTAL_TRAFFIC = loadTypes('FUNNEL_TOTAL_TRAFFIC')
export const FUNNEL_TRAFFIC_BY_CHANNELS = loadTypes('FUNNEL_TRAFFIC_BY_CHANNELS')
export const FUNNEL_CHANGE_SELECTED_CHANNELS = 'FUNNEL_CHANGE_SELECTED_CHANNELS'
export const FUNNEL_CONVERSION_DATA_CLEAR = 'FUNNEL_CONVERSION_DATA_CLEAR'

function processChannelTraffic(request, response) {
  if (!response || !response.length) return null
  const groupedGroups = groupBy(response, 'dimensions.channelGroup')
  const groups = Object.keys(groupedGroups).reduce((acc, group) => {
    return {
      ...acc,
      [group]: groupedGroups[group].reduce((sum, item) => {
        sum += item['session:count']
        return sum
      }, 0)
    }
  }, {})

  return response.reduce((acc, value) => {
    const {channel, channelGroup} = value.dimensions
    return {
      ...acc,
      [`${channelGroup}/${channel}`]: value['session:count']
    }
  }, groups)
}

function conversionReducer(state = {}, conversion) {
  return {
    ...state,
    ...conversion
  }
}

function conversionForChannelReducer(state = {}, conversion) {
  return {
    ...state,
    ...Object.keys(conversion).reduce((acc, key) => {
      acc[key] = conversionReducer(state[key], conversion[key])
      return acc
    }, {})
  }
}

function getChannelKey(channelGroup, channel) {
  if (channelGroup && channel) {
    return `${channelGroup}/${channel}`
  }
  if (channelGroup) {
    return channelGroup
  }

  return 'average'
}

function processConversion(request, response) {
  const {channelGroup, channel} = request.queryParams.filter || {}
  const key = getChannelKey(channelGroup, channel)
  const grouppedByStatus = groupBy(response, 'dimensions.funnelStatus')

  return Object.keys(grouppedByStatus).reduce((acc, status) => {
    return {
      ...acc,
      [status]: {
        [key]: grouppedByStatus[status][0]['session:count']
      }
    }
  }, {})
}

function processSelectedChannels(selectedChannels, index, value) {
  const newSelectedChannels = selectedChannels.concat()
  if (index < newSelectedChannels.length && value === undefined) {
    newSelectedChannels.splice(index, 1)
  } else if (index < newSelectedChannels.length) {
    newSelectedChannels[index] = value
  } else if (index === newSelectedChannels.length) {
    newSelectedChannels.push(null)
  }
  return newSelectedChannels
}

const initialState = {
  totalTraffic: null,
  channelTraffic: null,
  conversionAverage: null,
  conversionForChannel: null,
  selectedChannels: [null],

  totalTrafficFetching: false,
  totalTrafficFetchingErrorMessage: null,

  channelTrafficFetching: false,
  channelTrafficFetchingErrorMessage: null,

  conversionFetching: null,
  conversionFetchingErrorMessage: null,

  conversionForChannelFetching: null,
  conversionForChannelFetchingErrorMessage: null
}

export default function overview(state = initialState, action) {
  switch (action.type) {
    case FUNNEL_CONVERSION_DATA_CLEAR:
      return {
        ...state,
        totalTraffic: null,
        channelTraffic: null,
        conversionAverage: null,
        conversionForChannel: null
      }
    case FUNNEL_CONVERSION.REQUEST:
      return {
        ...state,
        conversionFetching: true
      }

    case FUNNEL_CONVERSION.SUCCESS:
      return {
        ...state,
        conversionFetching: false,
        conversionAverage: processConversion(action.request, action.response, state.totalTraffic)
      }

    case FUNNEL_CONVERSION.FAILURE:
      return {
        ...state,
        conversionFetching: false,
        conversionFetchingErrorMessage: action.message
      }

    case FUNNEL_CONVERSION_FOR_CHANNEL.REQUEST:
      return {
        ...state,
        conversionForChannelFetching: true
      }

    case FUNNEL_CONVERSION_FOR_CHANNEL.SUCCESS:
      return {
        ...state,
        conversionForChannelFetching: false,
        conversionForChannel: conversionForChannelReducer(
          state.conversionForChannel || {},
          processConversion(action.request, action.response)
        )
      }

    case FUNNEL_CONVERSION_FOR_CHANNEL.FAILURE:
      return {
        ...state,
        conversionForChannelFetching: false,
        conversionForChannelFetchingErrorMessage: action.message
      }

    case FUNNEL_TRAFFIC_BY_CHANNELS.REQUEST:
      return {
        ...state,
        channelTrafficFetching: true
      }

    case FUNNEL_TRAFFIC_BY_CHANNELS.SUCCESS:
      return {
        ...state,
        channelTrafficFetching: false,
        channelTraffic: processChannelTraffic(action.request, action.response)
      }

    case FUNNEL_TRAFFIC_BY_CHANNELS.FAILURE:
      return {
        ...state,
        channelTrafficFetching: false,
        channelTrafficFetchingErrorMessage: action.message
      }

    case FUNNEL_TOTAL_TRAFFIC.REQUEST:
      return {
        ...state,
        totalTrafficFetching: true
      }

    case FUNNEL_TOTAL_TRAFFIC.SUCCESS:
      return {
        ...state,
        totalTrafficFetching: false,
        totalTraffic: action.response[0]['session:count']
      }

    case FUNNEL_TOTAL_TRAFFIC.FAILURE:
      return {
        ...state,
        totalTrafficFetching: false,
        totalTrafficFetchingErrorMessage: action.message
      }

    case FUNNEL_CHANGE_SELECTED_CHANNELS:
      return {
        ...state,
        selectedChannels: processSelectedChannels(state.selectedChannels, action.index, action.value)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/funnels.js